import { LiveStatsTopics, STATS_TYPES, AGGREGATION_LEVELS } from '@ahaslides-product/frontend-toolkit'

const pollActions = {
  subscribePollUpdateAction: async ({ dispatch, getters }, { slide }) => {
    if (!slide || !slide.id) return
    const fromCounting = getters.canReadAnswertextFromCounting

    dispatch('subscribeCountingForSlideAction', { slide })

    if (slide.SlideOptions && slide.SlideOptions.length > 0) {
      if (!fromCounting) {
        dispatch('fetchStatsByWildCardAction', {
          path: `${STATS_TYPES.ANSWER_COUNT}/${AGGREGATION_LEVELS.PER_ANSWER_VALUE}/${slide.id}/${slide.version}`,
        })
      }
      await dispatch('fetchStatsByKeyAction', {
        statsKeys: [
          LiveStatsTopics.answererCountPerQuestionTopic(
            slide.id,
            0, // the default value for questionId
            slide.version,
          ),
        ],
      })
    }

    if (!fromCounting) {
      dispatch('subscribeStatsAction', {
        identifier: slide.id,
        statsType: STATS_TYPES.ANSWER_COUNT,
        aggregationLevel: AGGREGATION_LEVELS.PER_ANSWER_VALUE,
      })
    }

    dispatch('subscribeStatsAction', {
      identifier: slide.id,
      statsType: STATS_TYPES.ANSWERER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_QUESTION,
    })
  },

  unsubscribePollUpdateAction: ({ dispatch }, { slide }) => {
    if (!slide?.id) return
    dispatch('unsubscribeCountingForSlideAction', { slide })

    dispatch('unsubscribeStatsAction', {
      identifier: slide.id,
      statsType: STATS_TYPES.ANSWER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_ANSWER_VALUE,
    })

    dispatch('unsubscribeStatsAction', {
      identifier: slide.id,
      statsType: STATS_TYPES.ANSWERER_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_QUESTION,
    })
  },
}

export default pollActions
